export const PROFILE_TABS = {
  ACCOUNT: 'ACCOUNT',
  SERVICES: 'SERVICES',
};
